module.exports = __webpack_public_path__ + "2ed8053b4e0b41493e330eccf850a1b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/voucher/defaultVoucherImage.jpg
// module id = 101
// module chunks = 0